// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2dR-I","productName":"Table_productName__394Q5"};